<template>
    <div class="left-side-menu">
        <div class="slimscroll-menu">
            <div id="sidebar-menu" style="height: 550px; overflow: auto; position: relative; display: block;">
                <ul class="metismenu" id="side-menu">
                    <li class="menu-title">{{$t('string.msg.leftsidebar.label.title')}}</li>
                    <li v-bind:class="{ 'hidden': isAdminMaster() || hasType('FLEET_DRIVER') }">
                        <router-link to="/dashboard" class="cursor-pointer" >
                            <i class="dripicons-meter" style="color:#343B4A"></i>
                            <span>{{$t('string.msg.menu.dashboard.label.title')}}</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{ 'hidden': isAdminMaster() || !hasType('FLEET_DRIVER') }">
                        <router-link to="/dashboard-fleet-driver" class="cursor-pointer" >
                            <i class="dripicons-meter" style="color:#343B4A"></i>
                            <span>{{$t('string.msg.menu.dashboard.label.title')}}</span>
                        </router-link>
                    </li>
                    <li :class="{ 'hidden': !hasType('PART_SUPPLIER') }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="mdi mdi-wrench" style="color:#343B4A"></i>
                            <span>{{$t('string.msg.menu.register.parts.label.title')}}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <a @click="to('perfil-trucks')" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.parts.trucks.configuration.label.title")}}</span>
                                </a>
                            </li>
                            <li>
                                <router-link to="/perfil-trucks-trailer" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.parts.trucks.trailer.configuration.label.title")}}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li> 
                    <li v-bind:class="{ 'hidden': !hasType('SERVICE_PROVIDER') }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="mdi mdi-movie-roll" style="color:#343B4A"></i>
                            <span>{{$t('string.msg.menu.register.services.label.title')}}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <router-link to="/perfil-trucks-service" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.parts.services.configuration.label.title")}}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-bind:class="{ 'hidden': !hasType('CERTIFIER') }" class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="mdi mdi-book-outline" style="color:#343B4A"></i>
                            <span>{{$t('string.msg.menu.register.certified.label.title')}}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <router-link to="/perfil-certifies" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.parts.certifies.configuration.label.title")}}</span>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="item-with-submenus product">
                        <a href="javascript: void(0);">
                            <i class="fe-settings noti-icon" style="color:#343B4A"></i>
                            <span>{{$t('string.msg.menu.configurations.label.title')}}</span>
                            <span class="menu-arrow"></span>
                        </a>
                        <ul class="nav-second-level mm-collapse" aria-expanded="false">
                            <li>
                                <router-link to="/company-registration" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.company.registration.label.title")}}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ 'hidden': isAdminMaster() }"> 
                                <router-link to="/work-hours" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.additional.informations.label.title")}}</span>
                                </router-link>
                            </li>
                            <li v-bind:class="{ 'hidden': isAdminMaster() }">
                                <router-link to="/payment-method" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.payment.methods.label.title")}}</span>
                                </router-link>
                            </li>
                            
                            <li>
                                <router-link to="/crud-user" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.crud.user.label.title")}}</span>
                                </router-link>
                            </li>
                        
                            <li>
                                <router-link to="/change-password" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.change.password.label.title")}}</span>
                                </router-link>
                            </li>

                             <li>
                                <router-link to="/terms" class="cursor-pointer">
                                    <span>{{$t("string.msg.menu.terms.label.title")}}</span>
                                </router-link>
                            </li>

                        </ul>
                    </li>
                   </ul>
                <div style="margin-left:30px; color:green">
                    <label>{{$t('string.msg.platform.free.trial')}}</label>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtLeftSideBar';

export default {
  name: "LeftSideBar",
  components: {
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        user: {
            serviceTypes: []
        }
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
    $(".item-with-submenus > a").click(function () {
        $(this).parent().toggleClass("mm-active");
        $(this).parent().children("ul.nav-second-level.mm-collapse").toggleClass("mm-show");
    });
  }
}
</script>

<style scoped>
</style>